export default "__VITE_ASSET__41e2dca6__"